<template>
  <div>
    <v-dialog v-model="dialog" width="724" height="242">
      <v-card>
        <v-card-title class="text-h5 white--text third">
          Ajouter Participant
        </v-card-title>
        <v-card-text v-if="contracts.length" class="mt-2">
          <p class="text-center">
            les contrats actif suivant est compatible :
          </p>
          <v-select
            v-model="contractSelected"
            dense
            :items="selectContract"
            return-object
            item-text="label"
            label="sélectionner un contrat"
            chips
            persistent
            :menu-props="{ 'z-index': '1500 !important' }"
            required
            color="black"
          />
          <p class="text-center">
            (oui : décompter le(s) crédits
            non : offrir la séance)
          </p>
        </v-card-text>
        <v-card-text v-else class="mt-2">
          <p>
            Il n'y a pas de contrat actif pour cette session.
            Voulez-vous tout de même inscrire ce participant ?
          </p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            text
            :loading="loading"
            class="green white--text"
            :disabled="contracts.length && !contractSelected || (contractSelected && isObjectEmpty(contractSelected))"
            @click="reserveCustomerSession(true)"
          >
            <v-icon size="24" color="white" right class="mx-0 px-4">mdi-check</v-icon>
            Oui
          </v-btn>
          <v-btn v-if="contracts.length" depressed text class="blue white--text" :loading="loading" @click="reserveCustomerSession(false)">
            <v-icon size="24" color="white" right class="mx-0 px-4">mdi-reload</v-icon>
            non
          </v-btn>
          <v-btn depressed text class="red white--text" :loading="loading" @click="closeModal">
            <v-icon size="24" color="white" right class="mx-0 px-4">mdi-close</v-icon>
            Abandonner
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SessionEditOverlay
      v-if="!!selectParticipantModalData"
      style="z-index: 205;"
      :activator.sync="activatorModal"
      :change-confirmation-modal="changeEditSessionOverlay"
      :change-recurring-session="updateSessionParticipant"
      :current-session="selectParticipantModalData.session"
      :old-session-detail="selectParticipantModalData.session"
      :options="editOverlayOptions"
    />
    <SelectParticipantHorseModal
      v-if="horseModalDialog"
      v-model="horseModalDialog"
      :participant="selectParticipantModalData.user"
      :horses="customerHorses"
      :loading="horseModalLoading"
      @close-dialog="closeHorseModalDialog"
      @add-without-horse="addHorseToSessionOwnerParticipant"
      @add-with-horse="addHorseToSessionOwnerParticipant"
    />
  </div>
</template>

<script>
import { ref, computed, inject, watch, provide } from '@vue/composition-api';
import { isObjectEmpty, sendNotification, deleteOptions, stageRadioOptions } from '@/helpers/utils';
import { addParticipantToSession, addHorsesToSession } from '@/helpers/amplify';
import { sessionsWithPeriods, equestrianSession } from '@/helpers/sessions';
import SessionEditOverlay from '../sessions/createForm/SessionEditOverlay.vue';
import store from '@/store';
import SelectParticipantHorseModal from './SelectParticipantHorseModal.vue';

export default {
  components: { SessionEditOverlay, SelectParticipantHorseModal },
  setup () {
    const activatorModal = ref(false);
    const loading = ref(false);
    const dialog = inject('showParticipantModal');
    const selectParticipantModalData = inject('selectParticipantModalData');
    // const dialogParticipant = inject('addParticipantDialog');
    const selectedCustomer = inject('selectedParticipant');
    const isClubPassOwner = ref(false);
    
    const horseModalDialog = ref(false);
    const horseModalLoading = ref(false);

    const isEquestrianSession = computed(() => equestrianSession(selectParticipantModalData?.value?.session?.type));

    const contracts = computed(() => {
      if (!!selectParticipantModalData.value && (!isObjectEmpty(selectParticipantModalData.value))) {
        return (selectParticipantModalData.value.contracts || []).filter(contract => (selectParticipantModalData.value.session.product_activity || []).some(pa => pa.product === contract.productUuid) && contract.balance);
      }

      return [];
    });

    const user = computed(() => !!selectParticipantModalData.value && (!isObjectEmpty(selectParticipantModalData.value) ? selectParticipantModalData.value.user : null));
    const contractSelected = ref(null);
    const typeOfUpdate = ref(null);
    provide('newSession', selectParticipantModalData.value ? { value: selectParticipantModalData.value.session } : null);
    provide('oldSessionDetail', selectParticipantModalData.value ? { value: selectParticipantModalData.value.session } : null);
    provide('typeOfupdate', typeOfUpdate);
    const selectContract = computed(() => contracts.value.map(c => ({
      qrcode: c.qrcode,
      label: `${c.qrcode} - ${c.productLabel} - ${c.balance}  --  ${c.customerFirstname} ${c.customerLastname}`,
      quantity: c.balance,
      uuid: c.contractUuid,
      numeroContrat: c.contractNumber
    })));

    const customerHorses = computed(() => (store.getters.horsesFromCustomer(user.value.uuid) || []).map(horse => ({
      uuid: horse.uuid,
      horse_name: horse.wtitle,
      owners: horse.owners,
      participant: user.value.uuid,
      maxHoursEffort: horse.maxHoursEffort,
      wtype: horse.wtype
    })));

    const resetData = () => {
      typeOfUpdate.value = 'SINGLE';
      contractSelected.value = null;
    };
    const closeModal = () => {
      selectParticipantModalData.value = null;
      dialog.value = false;
      loading.value = false;
    };

    const openHorseModalDialog = () => {
      horseModalDialog.value = true;
    };

    const closeHorseModalDialog = () => {
      horseModalDialog.value = false;
    };

    const changeEditSessionOverlay = value => {
      activatorModal.value = value;
      loading.value = false;
    };

    const computeParticipantBody = () => {
      const participant = {
        qrcode: null,
        contract_number: null,
        horse: selectParticipantModalData?.value?.participantHorse ? selectParticipantModalData.value.participantHorse.horse : null,
        firstname: user.value.firstname,
        horanet_id: user.value.horanet_id,
        uuid: user.value.uuid,
        presence: null,
        presence_status: null,
        lastname: user.value.lastname,
        equestrianLevel: user.value.equestrian_level
      };

      if (contractSelected.value) {
        participant.qrcode = contractSelected.value.qrcode;
        participant.contract_number = contractSelected.value.numeroContrat;
      }

      if (isClubPassOwner.value) {
        participant.isClubParticipant = true;
        participant.contractOwner = true;
        participant.passOwnerUuid = user.value.uuid;
      }

      return participant;
    };

    const addHorseToSessionOwnerParticipant = async (addWithHorse, horse) => {
      horseModalLoading.value = true;
      const participantToAdd = computeParticipantBody();
      if (addWithHorse) {
        await addHorsesToSession(selectParticipantModalData.value.session.id, [horse], typeOfUpdate.value, null, false, false, participantToAdd);
      } else {
        await addParticipantToSession(selectParticipantModalData.value.session.id, participantToAdd, typeOfUpdate.value);
      }
      dialog.value = false;
      activatorModal.value = false;
      closeHorseModalDialog();
      selectedCustomer.value = null;
      loading.value = false;
      horseModalLoading.value = false;
    };

    const verifyHorseOwner = () => {
      // when its no '+' button and customer has horses
      if (selectParticipantModalData?.value?.participantHorse || !customerHorses.value.length || !isEquestrianSession.value) {
        return false;
      }

      if (customerHorses.value.length === 1) {
        addHorseToSessionOwnerParticipant(true, customerHorses.value[0]);
        return true;
      }

      if (customerHorses.value.length > 1) {
        loading.value = false;
        openHorseModalDialog();
        return true;
      }
      return false;
    };

    const reserveCustomerSession = async addWithContract => {
      loading.value = true;
      if (!contractSelected.value && contracts.value.length && addWithContract) {
        sendNotification('error', 'Veuillez sélectionner un contrat');
        loading.value = false;
        return;
      }

      const participantToAdd = computeParticipantBody();

      const { session } = selectParticipantModalData.value;
      if (!session.recurring) {
        if (verifyHorseOwner()) {
          return;
        }

        await addParticipantToSession(session.id, participantToAdd);
        dialog.value = false;
        loading.value = false;
        // dialogParticipant.value = false;
        selectedCustomer.value = null;
        return;
      }

      loading.value = false;
      activatorModal.value = true;
    };
    const updateSessionParticipant = async () => {
      activatorModal.value = false;
      loading.value = true;

      const participant = computeParticipantBody();

      if (verifyHorseOwner()) {
        return;
      }

      await addParticipantToSession(selectParticipantModalData.value.session.id, participant, typeOfUpdate.value);
      selectParticipantModalData.value = null;
      loading.value = false;
      dialog.value = false;
    };

    const checkClubPassOwner = async () => {
      if(!selectParticipantModalData.value || !selectParticipantModalData.value.session) return;

      const { session } = selectParticipantModalData.value;
      //if the user is not in the session and there is a clubParticipant with passOwnerUuid equal to user.uuid, then add the user to the session with contract and clubPass fields
      if(!(session.participants || []).some(p => p.uuid === user.value.uuid) && (session.participants || []).some(p => p.passOwnerUuid === user.value.uuid)) {
        const clubParticipant = (session.participants || []).find(p => p.passOwnerUuid === user.value.uuid);
        contractSelected.value = selectContract.value.find(c => parseInt(c.numeroContrat) === parseInt(clubParticipant.contract_number));
        isClubPassOwner.value = true;
        await reserveCustomerSession(true);
      }
    };

    watch(dialog, async () => {
      resetData();
      await checkClubPassOwner();
    });

    const editOverlayOptions = computed(() => {
      if (sessionsWithPeriods.includes(selectParticipantModalData.value.session.type)) {
        return stageRadioOptions;
      }
      return deleteOptions;
    });

    return { editOverlayOptions, updateSessionParticipant, activatorModal, changeEditSessionOverlay, addParticipantToSession, loading, selectParticipantModalData, reserveCustomerSession, contractSelected, selectContract, dialog, closeModal, contracts, isObjectEmpty, customerHorses, horseModalDialog, closeHorseModalDialog, addHorseToSessionOwnerParticipant, horseModalLoading };
  }
};
</script>

<style>

</style>
